import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { format, parse, startOfMonth, set } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import Reorder from '@material-ui/icons/Reorder';
import TextField from '@material-ui/core/TextField';
import EditIcon from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import AllowanceDialog from '../../components/Allowance/AllowanceDialog';
import AllowanceEditDialog from '../../components/Allowance/AllowanceEditDialog';
import { fetchVacations, deleteVacations } from '../../store/actions/vacation';
import { fetchEmployees } from '../../store/actions/employee';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import SelectTable from '../../components/DataTable/SelectTable';
import Input from '../../components/Input/Input';

const styles = theme => ({
  input: {
    width: '40%',
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
    border: '1px solid',
    borderColor: theme.palette.grey[400],
  },
  optionsButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
});

class Allowances extends React.Component {
  state = {
    editField: null,
    open: false,
    anchorEl: null,
    selected: [],
    selectedEdit: null,
    searchQuery: '',
    openModal: false,
    openEditModal: false,
    openErrorModal: false,
    openDeleteModal: false,
    startDate: '',
    endDate: '',
    allowances: [],
    currentItem: {
      id: null,
      name: '',
      type: null,
      observation: null,
    },
  };

  componentWillMount() {
    this.setState({
      startDate: startOfMonth(new Date()),
      endDate: set(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
    });
  }

  componentDidMount() {
    this.props.onFetchVacations(
      format(startOfMonth(new Date()), 'yyyy-MM-dd'),
      format(new Date(), 'yyyy-MM-dd'),
    );
    this.props.onFetchEmployees();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vacations && nextProps.employees) {
      const newAllowance = [];

      nextProps.vacations.map(vacation =>
        nextProps.employees.map((employee) => {
          if (employee.id === vacation.employeeId) {
            return newAllowance.push({
              id: vacation.id,
              enrollment: employee.enrollment,
              department: employee._department,
              observation: vacation.observation,
              _office: employee._office,
              name: employee.name,
              categoryOriginal: vacation.category,
              category: this.handleCategory(vacation.category),
              compensationDate: vacation.compensationDate,
              allowanceHours: vacation.allowanceHours,
              dtFromOriginal: vacation.dtFrom,
              dtToOriginal: vacation.dtTo,
              dtFrom: format(parse(vacation.dtFrom, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'),
              dtTo: format(parse(vacation.dtTo, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'),
            });
          }
          return newAllowance;
        }));
      Promise.all(newAllowance).then(() => {
        this.setState({ allowances: newAllowance, selected: [] });
      });
    }
  }

  handleCategory = (category) => {
    switch (category) {
      case 'VACATION':
        return 'Férias';
      case 'JUST_ABS':
        return 'Faltas Justificadas';
      case 'OPTIONAL_DAY':
        return 'Ponto Facultativo';
      case 'WORK_LEAVE':
        return 'Dia de Folga';
      case 'LEAVE_OF_ABSENCE':
        return 'Licença/Afastamento';
      case 'SUNDAY_OR_HOLIDAY_COMPENSATION':
        return 'Compensação de Domingo/Feriado';
      case 'ALLOWANCE_HOURS':
        return 'Abono de horas';
      case 'OUT_JUST_ABSENCE':
        return 'Falta sem Justificativa';
      default:
        break;
    }
  };

  handleToggle = () => {
    this.setState({ open: !this.state.open });
  };

  handleCloseEdit = () => {
    this.setState({ anchorEl: null });
  };

  handleClickEdit = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = (event) => {
    if (this.target1.contains(event.target) || this.target2.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  handleEdit = (field) => {
    this.setState({ editField: String(field), openModal: true });
  };

  handleActionCancel = () => {
    this.setState({ openModal: false });
    this.setState({ openEditModal: false });
    this.setState({ openDeleteModal: false });
    this.setState({ openErrorModal: false });
  };

  handleInputChange = name => (event) => {
    try {
      if (event != null) {
        if (event.target) {
          this.setState({ [name]: event.target.value });
        } else {
          this.setState({ [name]: event });
        }
      }
    } catch (error) {
      console.log(error)
    }
  };

  handleDeleteConfirm = () => {
    this.props.onDeleteVacations({ ids: [this.state.currentItem.id] });
    this.setState({ openDeleteModal: false });
  };

  handleActionClick = (action, item) => {
    switch (action) {
      case 'Editar':
        if (item) {
          this.setState({ openModal: true, currentItem: item });
        } else {
          this.setState({
            openModal: true,
            currentItem: { id: null, name: '' },
          });
        }
        break;

      case 'EditarModal':
        if (item) {
          this.setState({ openEditModal: true, currentItem: item });
        } else {
          this.setState({
            openModal: true,
            currentItem: { id: null, name: '' },
          });
        }
        break;

      case 'Excluir':
        if (item) {
          this.setState({
            openDeleteModal: true,
            currentItem: item,
          });
        } else {
          this.setState({
            openDeleteModal: true,
            currentItem: { id: null, name: '' },
          });
        }
        break;

      case 'Error':
        this.setState({ openErrorModal: true });
        break;

      default:
        break;
    }
  };

  handleSelectAll = (event, checked, searchSelect) => {
    const searchIndex = searchSelect.map(allowance => allowance.id);

    if (checked) {
      const newSelected = this.state.selected.slice();

      if (searchIndex) {
        if (this.state.selected.indexOf(searchIndex[0]) === -1) {
          this.state.allowances.map(allowance =>
          (searchIndex.indexOf(allowance.id) > -1 && newSelected.indexOf(allowance.id) === -1
            ? newSelected.push(allowance.id)
            : null));
        } else {
          this.state.allowances.map(allowance =>
          (searchIndex.indexOf(allowance.id) > -1
            ? newSelected.splice(newSelected.indexOf(allowance.id), 1)
            : null));
        }
      }

      this.setState({ selected: newSelected });
    } else if (searchIndex.length === this.state.allowances.length) {
      this.setState({ selected: [] });
    } else {
      const newSelected = this.state.selected.slice();
      this.state.allowances.map(allowance =>
      (searchIndex.indexOf(allowance.id) > -1
        ? newSelected.splice(newSelected.indexOf(allowance.id), 1)
        : null));

      this.setState({ selected: newSelected });
    }
  };

  handleSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, loading, onFetchVacations } = this.props;
    const {
      openModal,
      openEditModal,
      openDeleteModal,
      editField,
      selected,
      searchQuery,
      startDate,
      endDate,
      allowances,
      anchorEl,
      openErrorModal,
      currentItem,
    } = this.state;

    const columns = [
      { name: 'enrollment', label: 'Matrícula' },
      { name: 'name', label: 'Nome' },
      { name: 'department', label: 'Departamento' },
      { name: 'category', label: 'Tipo' },
      { name: 'dtFrom', label: 'Início' },
      { name: 'dtTo', label: 'Final' },
    ];

    const searchFields = ['enrollment', 'name', 'department', 'category', 'dtFrom', 'dtTo'];

    const actions = [
      {
        name: 'Excluir',
        icon: DeleteIcon,
        handleClick: item => this.handleActionClick('Excluir', item),
      },
      {
        name: 'Editar',
        icon: EditIcon,
        handleClick: item => this.handleActionClick('EditarModal', item),
      },
    ];


    return (
      <React.Fragment>
        <ContentHeader
          title="Listagem de Férias, Folgas, Faltas Justificadas e Licenças"
          subtitle="Listagem dos abonos cedidos pela empresa"
        >
          <Button
            aria-owns={anchorEl ? 'simple-menu' : null}
            aria-haspopup="true"
            variant="contained"
            color="primary"
            onClick={this.handleClickEdit}
          >
            <Reorder /> OPÇÕES
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleCloseEdit}
          >
            <MenuItem onClick={this.handleCloseEdit}>
              <Button className={classes.optionsButton} component={Link} to="/abonos/cadastrar">
                {' '}
                <AddIcon /> Cadastrar{' '}
              </Button>
            </MenuItem>
            <hr />
            <MenuItem onClick={this.handleCloseEdit}>
              <Button
                className={classes.optionsButton}
                onClick={
                  selected.length === 0
                    ? () => this.handleActionClick('Error')
                    : () => this.handleEdit('Tipo')
                }
              >
                {' '}
                <EditIcon /> Tipo do Abono{' '}
              </Button>
            </MenuItem>
            <MenuItem onClick={this.handleCloseEdit}>
              <Button
                className={classes.optionsButton}
                onClick={
                  selected.length === 0
                    ? () => this.handleActionClick('Error')
                    : () => this.handleEdit('Observação')
                }
              >
                {' '}
                <EditIcon /> Observação do Abono{' '}
              </Button>
            </MenuItem>
            <MenuItem onClick={this.handleCloseEdit}>
              <Button
                className={classes.optionsButton}
                onClick={
                  selected.length === 0
                    ? () => this.handleActionClick('Error')
                    : () => this.handleEdit('Período')
                }
              >
                {' '}
                <EditIcon /> Período do Abono{' '}
              </Button>
            </MenuItem>
          </Menu>
        </ContentHeader>

        <Paper elevation={2}>
          <Grid container justify="space-between" alignItems="center" spacing={3}>
            <Grid item>
              <div style={{ width: '91.28px' }} />
            </Grid>
            <Grid item>
              <Input
                elementType="datePicker"
                style={{ marginRight: '40px' }}
                label="Início do período"
                margin="normal"
                value={startDate}
                onChange={this.handleInputChange('startDate')}
              />
              <Input
                elementType="datePicker"
                label="Fim do período"
                minDate={startDate}
                margin="normal"
                value={endDate}
                onChange={this.handleInputChange('endDate')}
              />
            </Grid>
            <Grid item>
              <Button
                color="secondary"
                className={classes.button}
                onClick={() => {
                  onFetchVacations(format(startDate, 'yyyy-MM-dd'), format(endDate, 'yyyy-MM-dd'));
                }}
              >
                BUSCAR
              </Button>
            </Grid>
          </Grid>

          <TextField
            className={classes.input}
            value={searchQuery}
            onChange={this.handleInputChange('searchQuery')}
            placeholder="Buscar"
            type="text"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="disabled" />
                </InputAdornment>
              ),
            }}
          />

          <SelectTable
            rows={allowances}
            columns={columns}
            actions={actions}
            searchFields={searchFields}
            loading={loading}
            onSelect={this.handleSelect}
            onSelectAll={this.handleSelectAll}
            checkSelect={this.isSelected}
            numSelected={selected.length}
            searchQuery={searchQuery.toUpperCase()}
          />
        </Paper>

        <AllowanceDialog
          open={openModal}
          onClose={this.handleActionCancel}
          title="Editar"
          editField={editField}
          loading={loading}
          selected={selected}
        />
        <AllowanceEditDialog
          open={openEditModal}
          onClose={this.handleActionCancel}
          title="Editar"
          editField={editField}
          loading={loading}
          selected={selected}
          item={currentItem.id}
          allowance={allowances}
        />


        <Dialog open={openErrorModal} onClose={this.handleActionCancel}>
          <DialogTitle>Selecione um Abono</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Você deve selecionar pelo menos um abono para editar.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            <Button onClick={this.handleActionCancel} variant="contained" color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openDeleteModal} onClose={this.handleActionCancel}>
          <DialogTitle>Excluir abono</DialogTitle>
          <DialogContent>
            <DialogContentText>Você tem certeza que deseja efetuar esta ação?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            <Button onClick={this.handleDeleteConfirm} variant="contained" color="primary" autoFocus>
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  vacations: state.vacation.vacations,
  employees: state.employee.employees,
  schedules: state.schedule.schedules.map(schedule => schedule.workingDay),
});

const mapDispatchToProps = dispatch => ({
  onFetchVacations: (dtFrom, dtTo) => dispatch(fetchVacations(dtFrom, dtTo)),
  onDeleteVacations: vacations => dispatch(deleteVacations(vacations)),
  onFetchEmployees: () => dispatch(fetchEmployees()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(Allowances));
